import { SIZES, DEVICES } from '../../constants'
import { objectValues } from './Object'

export function detectDevice () {
  let device = DEVICES.DESKTOP

  if (typeof window !== 'undefined') {
    if (window.innerWidth < SIZES.BREAKPOINT_XS) {
      device = DEVICES.MOBILE
    } else if (window.innerWidth >= SIZES.BREAKPOINT_XS && window.innerWidth < SIZES.BREAKPOINT_MD) {
      device = DEVICES.TABLET
    }
  }

  return device
}

export function isValidDevice (device) {
  return objectValues(DEVICES).indexOf(device) !== -1
}
